module.exports = __webpack_public_path__ + "img/logo_en.7745e94c.svg";